import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { CTAButton } from './ui/CTAButton';
export function Hero() {
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatedSection className="pt-16 pb-20 px-6 md:px-12 max-w-7xl mx-auto" data-id="element-93">
      <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-94">
        <div className="flex-1 space-y-8 text-center lg:text-left" data-id="element-95">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold" data-id="element-96">
            Recupera tu cuerpo: baja la inflamación en 14 días con productos a
            tu alcance
          </h1>
          <h2 className="text-xl md:text-2xl text-brand-gray/80 font-medium max-w-2xl mx-auto lg:mx-0" data-id="element-97">
            Recupera la agilidad de tus manos y rodillas sin comprar suplementos
            caros ni pisar tiendas de lujo.
          </h2>
          <div className="pt-4" data-id="element-98">
            <CTAButton onClick={scrollToOffer} data-id="element-99">
              ¡Sí, quiero volver a moverme sin dolor!
            </CTAButton>
          </div>
        </div>
        <div className="flex-1 w-full max-w-xl lg:max-w-none" data-id="element-100">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-101">
            <img src="https://cdn.magicpatterns.com/uploads/9hmNtdgxk2jsSTFnYc6RN3/heylloyd-image-1774575141846.png" alt="Mujer mayor sonriendo mientras lee la guía de cocina anti-inflamatoria en su laptop" className="w-full h-auto object-cover" data-id="element-102" />
          </div>
        </div>
      </div>
    </AnimatedSection>;
}